import { render, staticRenderFns } from "./MessagesAnnoucement.vue?vue&type=template&id=229fa29b&"
import script from "./MessagesAnnoucement.vue?vue&type=script&lang=js&"
export * from "./MessagesAnnoucement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229fa29b')) {
      api.createRecord('229fa29b', component.options)
    } else {
      api.reload('229fa29b', component.options)
    }
    module.hot.accept("./MessagesAnnoucement.vue?vue&type=template&id=229fa29b&", function () {
      api.rerender('229fa29b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessagesAnnoucement.vue"
export default component.exports